import React from 'react';
import { useParams } from 'react-router-dom';
import { appConfig } from '../../../common/config';
import LayoutStandard from '../../../layouts/layout_standard';
import DeviceInstallation from './device_installation';

interface RouteParams {
  deviceIdOrSerial: string;
  [key: string]: string;
}

interface IInstallDevicePageProps {
}

const InstallDevicePage: React.FC<IInstallDevicePageProps> = () => {
  const { deviceIdOrSerial } = useParams<RouteParams>();

  return (
    <LayoutStandard page={appConfig.pages.installDevice}>
      <DeviceInstallation deviceIdOrSerial={deviceIdOrSerial}/>
    </LayoutStandard>
  );
};

export default InstallDevicePage;

